
import Api from "@/api/userService";
import BarChart from "@/components/BarChart.vue";
import LineChart from "@/components/LineChart.vue";
import PieChart from "@/components/PieChart.vue";
import RaddarChart from "@/components/RaddarChart.vue";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { fromatDateYM } from "@/utils/MyUtils";
import dayjs, { Dayjs } from "dayjs";
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import VisualizationTable from "./VisualizationTable.vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "VisualizationPage",
  components: {
    LineChart,
    RaddarChart,
    PieChart,
    BarChart,
    VisualizationTable,
  },
  props: {},
  setup() {
    const { t } = useI18n();

    const start = new Date();
    start.setTime(start.getTime() - 1000 * 60);
    const statisticsTime = ref<Dayjs>(
      dayjs(fromatDateYM(start), "YYYY-MM-DD HH:mm:ss")
    );
    const detail = ref();
    const result = new Map();
    const isShow = ref(false);
    const carVin = useRoute().query && (useRoute().query.vin as string);
    const parm = ref({
      vin: carVin,
      start_time: "",
    });
    const onChange = () => {
      getVisualization();
    };
    const disabledDate = (current: Dayjs) => {
      return current && current > dayjs().endOf("day");
    };
    const getVisualization = () => {
      parm.value.start_time = fromatDateYM(
        new Date(statisticsTime.value.toDate())
      );
      Api.getVisualization(parm.value).then((res) => {
        if (res.err_no === ResultCodeType.success_200) {
          detail.value = res.result;
          for (let key in detail.value) {
            if (key !== "xtime_data" && key !== "data") {
              result.set(key, detail.value[key]);
              if (Array.isArray(detail.value[key])) {
                detail.value[key] = detail.value[key].map((value: string) =>
                  Number(value)
                );
              }
            }
          }
        }
      });
    };
    const showType = () => {
      isShow.value = !isShow.value;
    };
    onMounted(() => {
      getVisualization();
    });
    return {
      onChange,
      statisticsTime,
      disabledDate,
      dayjs,
      showType,
      detail,
      isShow,
      routerName,
      t,
    };
  },
});
